import { render, staticRenderFns } from "./CoachDetail.vue?vue&type=template&id=753bd6c0&scoped=true"
import script from "./CoachDetail.vue?vue&type=script&lang=js"
export * from "./CoachDetail.vue?vue&type=script&lang=js"
import style0 from "./CoachDetail.vue?vue&type=style&index=0&id=753bd6c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753bd6c0",
  null
  
)

export default component.exports